"use client"

import Script from 'next/script'

export default function WebVitalsScript() {
  return (
    <Script 
      id="web-vitals"
      strategy="lazyOnload"
      src="https://unpkg.com/web-vitals@3/dist/web-vitals.attribution.iife.js"
      onLoad={() => {
        // Envia os Web Vitals para console apenas em ambiente de desenvolvimento
        if (process.env.NODE_ENV === 'development') {
          // @ts-expect-error - Web Vitals global não é tipado
          window.webVitals.onCLS(console.log);
          // @ts-expect-error - Web Vitals global não é tipado
          window.webVitals.onFID(console.log);
          // @ts-expect-error - Web Vitals global não é tipado
          window.webVitals.onLCP(console.log);
          // @ts-expect-error - Web Vitals global não é tipado
          window.webVitals.onFCP(console.log);
          // @ts-expect-error - Web Vitals global não é tipado
          window.webVitals.onTTFB(console.log);
          // @ts-expect-error - Web Vitals global não é tipado
          window.webVitals.onINP(console.log);
        } else {
          // Em produção, poderia enviar para um serviço de analytics
          // mas não vamos bloquer a execução com logs
          const sendToAnalytics = (/* metric */) => {
            // Implementação futura para enviar métricas para um serviço de analytics
            // Por enquanto, não faz nada
          };
          
          // @ts-expect-error - Web Vitals global não é tipado
          window.webVitals.onCLS(sendToAnalytics);
          // @ts-expect-error - Web Vitals global não é tipado
          window.webVitals.onFID(sendToAnalytics);
          // @ts-expect-error - Web Vitals global não é tipado
          window.webVitals.onLCP(sendToAnalytics);
          // @ts-expect-error - Web Vitals global não é tipado
          window.webVitals.onFCP(sendToAnalytics);
          // @ts-expect-error - Web Vitals global não é tipado
          window.webVitals.onTTFB(sendToAnalytics);
          // @ts-expect-error - Web Vitals global não é tipado
          window.webVitals.onINP(sendToAnalytics);
        }
      }}
    />
  )
} 